import React from "react";
import { BaseButton } from "@wantable/Shared/Components";
import { useAuth } from "@wantable/Shared/Hooks";

interface IUserDropdown {
  onLogout: () => void;
}

const UserDropdown = ({ onLogout }: IUserDropdown) => (
  <ul className="dropBox flex flex-col absolute bg-white top-[100%] z-1000">
    <li className="pt-[10px]"></li>
    {window &&
      window.WANTABLE_header.userLinks.map(({ url, label, target }) => (
        <li className="h-40 flex flex-col justify-center px-15" key={label}>
          <a href={url} className="text-[12px] text-grey-600" target={target}>
            {label}
          </a>
        </li>
      ))}
      <li className="pb-10"></li>
      <li className="h-40 flex flex-col justify-center items-start border-t border-grey-200">
        <button className="text-[12px] text-grey-600 px-15" onClick={() => {onLogout(); useAuth().logout();}}>Log Out</button>
      </li>
  </ul>
);

export default UserDropdown;
